import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { AuthService } from "../auth/auth.service";
import { StorageService } from "../helpers/storage.service";


@Injectable({
  providedIn: "root",
})
export class LoggedInGuard  {
  userToken: string = "";

  constructor(
    private router: Router,
    private authService: AuthService,
    private storage: StorageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.storage.getCurrentUser()) {
      return true;
    } else {
      this.authService.logout();
      return false;
    }
  }
}
